import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const Btn = styled.button`
    position: absolute;
    top: 18px;
    right: 18px;
    cursor: pointer;
    background: transparent;
    border: none;
    z-index: 10;

    @media screen and (max-width: 560px) {
        top: 10px;
        right: 10px;
    }
`;
const CloseBtn = ({ handleClick }) => {
    return (
        <Btn type="button" onClick={handleClick}>
            <CloseRoundedIcon fontSize="medium" />
        </Btn>
    );
};
CloseBtn.propTypes = {
    handleClick: PropTypes.func,
};
export default CloseBtn;
